import { Button, Form, Input, Switch } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Exam, ExamGroup } from "@types";
import { useEffect } from "react";
import { useAddExamGroup, useEditExamGroup } from "@hooks";
import { useTranslation } from "react-i18next";

interface Props {
  examGroup?: ExamGroup;
  exam?: Exam;
  examGroupLength?: number;
  setIsModalOpen: (value: boolean) => void;
}

export const ExamQuestionGroupForm = ({ examGroup, exam, examGroupLength, setIsModalOpen }: Props) => {
  const [groupQuestionForm] = Form.useForm();
  const {t} = useTranslation();
  const addExamGroup = useAddExamGroup();
  const editExamGroup = useEditExamGroup();

  useEffect(() => {
    if (examGroup) {
      groupQuestionForm.setFieldsValue(examGroup);
    }
  }, [examGroup]);

  const onFinish = (values: any) => {
    if (examGroup) {
      editExamGroup.mutate(
        { ...values, id: examGroup.id, state: values.state ? 1 : 2 },
        { onSuccess: () => setIsModalOpen(false) }
      );
    } else {
      addExamGroup.mutate(
        {
          ...values,
          examId: exam?.id,
          state: values.state ? 1 : 2,
          orderNumber: examGroupLength,
        },
        { onSuccess: () => setIsModalOpen(false) }
      );
    }
  };

  return (
    <Form layout="vertical" form={groupQuestionForm} onFinish={onFinish}>
      <Form.Item
        label={t("forms.questionGroup.name")}
        name={["name"]}
        rules={[{ required: true, message: t("forms.questionGroup.nameDesc") }]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={t("forms.questionGroup.description")} name={["description"]}>
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        initialValue={true}
        label={t("table.status")}
        name={["state"]}
      >
        <Switch />
      </Form.Item>
      <Form.Item
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          marginBottom: 0,
          marginTop: 8,
        }}
      >
        <Button type="primary" htmlType="submit" loading={examGroup ? editExamGroup.isPending : addExamGroup.isPending}>
          {t("forms.questionGroup.save")}
        </Button>
      </Form.Item>
    </Form>
  );
};
